/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finetune_The_Data_For_YourInputs */

const en_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine-tune the data for your`)
};

const es_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusta los datos de tu`)
};

const fr_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustez les données pour votre`)
};

const de_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimiere die Daten für dein`)
};

const ja_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データを微調整する対象:`)
};

const zh_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为您的商品微调数据`)
};

const ar_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بتحسين البيانات الخاصة بـ`)
};

const id_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesuaikan data untuk listing Anda`)
};

const it_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliora i dati per il tuo`)
};

const ru_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Точная настройка данных для вашего объявления`)
};

const pt_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste fino dos dados para o seu`)
};

const ko_finetune_the_data_for_your = /** @type {(inputs: Finetune_The_Data_For_YourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 데이터를 세밀하게 조정하세요`)
};

/**
* | output |
* | --- |
* | "Fine-tune the data for your" |
*
* @param {Finetune_The_Data_For_YourInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const finetune_the_data_for_your = /** @type {((inputs?: Finetune_The_Data_For_YourInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finetune_The_Data_For_YourInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_finetune_the_data_for_your(inputs)
	if (locale === "es") return es_finetune_the_data_for_your(inputs)
	if (locale === "fr") return fr_finetune_the_data_for_your(inputs)
	if (locale === "de") return de_finetune_the_data_for_your(inputs)
	if (locale === "ja") return ja_finetune_the_data_for_your(inputs)
	if (locale === "zh") return zh_finetune_the_data_for_your(inputs)
	if (locale === "ar") return ar_finetune_the_data_for_your(inputs)
	if (locale === "id") return id_finetune_the_data_for_your(inputs)
	if (locale === "it") return it_finetune_the_data_for_your(inputs)
	if (locale === "ru") return ru_finetune_the_data_for_your(inputs)
	if (locale === "pt") return pt_finetune_the_data_for_your(inputs)
	return ko_finetune_the_data_for_your(inputs)
});